import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import React, {forwardRef, useEffect} from "react";
import Paper from "@material-ui/core/Paper";
import {
    AddBox, NavigateNext,
} from "@material-ui/icons";
import _ from "lodash";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import CorporateImage from '../../../assets/img/corporate-1-slider-slide-2.jpg';


function IntradayHeader({ redcer,errors, auth, /* functions */ }) {

    useEffect(() => {
        // Initialization
        // if (_.isEmpty(data)) {
        //     getData({});
        // }
    }, []);

    // change in data
    // useEffect(() => {
    //     if (!_.isEmpty(redcer.data)) {
    //         setData(redcer.data);
    //         errors = {};
    //     }
    // }, [redcer.data]);



    return (
        <div className="dark-translucent-bg" style={{backgroundImage: `url(${CorporateImage})`, backgroundPosition: '50% 32%'}}>
            {/* breadcrumb start */}
            {/* ================ */}
            <div className="breadcrumb-container">
                <div className="container">
                    <Breadcrumbs separator={<NavigateNext fontSize="small" />} aria-label="breadcrumb">
                        <Link color="textPrimary" href="/" >
                            Home
                        </Link>
                        <Link color="textPrimary" href="">
                            Intraday
                        </Link>
                    </Breadcrumbs>
                </div>
            </div>
            {/* breadcrumb end */}

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 text-center pv-20">
                        <h2 className="title " data-animation-effect="fadeIn" data-effect-delay={100}><strong>Intraday
                            Calls</strong></h2>
                        <div className="separator mt-10" data-animation-effect="fadeIn" data-effect-delay={100} />
                    </div>
                </div>
            </div>
        </div>
    )
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors,
});

export default withRouter(connect(mapStateToProps, {
    //functions
})(IntradayHeader));
